import React, { useEffect, useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { TableBox, SearchFilter, Paging } from '../../components';
import { usePagination, useFilter } from '../../hooks';
import { SnackbarContext } from '../../contexts';
import Handler from '../../Handler';
import API from '../../api';

export const MemberPersonalListPage = (props) => {
  const history = useHistory();
  const { updateSnackbar } = useContext(SnackbarContext);
  const [list, setList] = useState(null);
  const [header, setHeader] = useState([
    {
      key: 'seq',
      align: 'center',
      text: 'No',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'joinedType',
      align: 'center',
      text: '가입 구분',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        console.log('render value', value);
        switch (value) {
          case 'Email': {
            return '이메일';
          }
          case 'Kakao': {
            return '카카오';
          }
          case 'Google': {
            return '구글';
          }
          default: {
            return '';
          }
        }
      },
    },
    {
      key: 'name',
      align: 'center',
      text: '이름',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'email',
      align: 'center',
      text: '이메일',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'phone',
      align: 'center',
      text: '전화번호',
      style: {
        minWidth: 100,
      },
    },
    {
      key: 'createdAt',
      align: 'center',
      text: '가입일',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        return Handler.getYYYYMMDDByUnix(value);
      },
    },
    // {
    //   key: 'marketingAgreeDate',
    //   align: 'center',
    //   text: '마케팅 수신 동의',
    //   style: {
    //     minWidth: 100,
    //   },
    //   render: (value) => {
    //     console.log('render value', value);
    //     if (value) {
    //       return 'O';
    //     } else {
    //       return 'X';
    //     }
    //   },
    // },
    {
      key: 'status',
      align: 'center',
      text: '상태',
      style: {
        minWidth: 100,
      },
      render: (value) => {
        console.log('render value', value);
        switch (value) {
          case 'Registered': {
            return '가입 등록';
          }
          case 'Certification': {
            return '메일 승인 대기';
          }
          case 'ApproveRequired': {
            return '관리자 승인 대기';
          }
          case 'Confirmed': {
            return '승인 완료';
          }
          case 'Disabled': {
            return '사용 불가';
          }
          default: {
            return '';
          }
        }
      },
    },
  ]);

  const [filter, onFilterChange, setFiler] = useFilter([
    {
      key: 'joinedType',
      type: 'select',
      label: '가입 구분',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
        {
          value: 'Email',
          label: '이메일',
        },
        {
          value: 'Kakao',
          label: '카카오',
        },
        {
          value: 'Google',
          label: '구글',
        },
      ],
    },
    // {
    //   key: 'isMarketingAgree',
    //   type: 'select',
    //   label: '마켓팅 수신 동의',
    //   value: 'SELECT_ALL',
    //   menus: [
    //     {
    //       value: 'SELECT_ALL',
    //       label: '전체',
    //     },
    //     {
    //       value: 'true',
    //       label: '수신 동의',
    //     },
    //     {
    //       value: 'false',
    //       label: '수신 거부',
    //     },
    //   ],
    // },
    {
      key: 'signoutStatus',
      type: 'select',
      label: '탈퇴 여부',
      value: 'SELECT_ALL',
      menus: [
        {
          value: 'SELECT_ALL',
          label: '전체',
        },
        {
          value: 'SignoutNone',
          label: '일반 유저',
        },
        {
          value: 'SignoutRequest',
          label: '탈퇴 요청',
        },
        {
          value: 'SignoutComplete',
          label: '탈퇴 유저',
        },
      ],
    },
    {
      key: 'searchType',
      type: 'select',
      label: '검색 종류',
      value: 'Name',
      menus: [
        {
          value: 'Name',
          label: '이름',
        },
        {
          value: 'Phone',
          label: '전화번호',
        },
        {
          value: 'Email',
          label: '이메일',
        },
      ],
    },
    {
      key: 'searchValue',
      type: 'input',
      label: '검색 값',
      value: '',
      inputType: 'text',
    },
  ]);
  const [page, totalPage, totalCount, onPageChange, setPage, setTotalPage, setTotalCount] = usePagination(0, 9);

  const tableCallback = (type, index) => {
    console.log('tableCallback type', type);
    console.log('tableCallback index', index);
  };

  const tableRowClick = (index) => {
    console.log('tableRowClick index', index);
    let target_seq = list[index].seq;
    console.log('tableRowClick target_seq', target_seq);
    history.push('/member/personal/detail/' + target_seq);
  };

  const onSearch = (body) => {
    console.log('onSearch', body);
    requestNewList(0);
  };

  useEffect(() => {
    console.log('page effect', page);
    requestNewList();
  }, [page]);

  const requestNewList = (init_page) => {
    let body = Handler.filterToBody(filter);
    console.log('page body', body);
    API.Member.GetMemberList({
      ...body,
      type: 'Personal',
      page: init_page ? init_page : page,
      size: Handler.VARIABLES.PAGE_LIMIT,
    }).then(
      (res) => {
        console.log('res', res);
        let result = res.data;
        setList(result.content);
        setTotalPage(result.totalPages);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  const requsetAdd = () => {
    console.log('requsetAdd');
  };

  console.log('list', list);

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>개인회원 목록</h3>
        </header>
      </section>
      <section className='filter__container'>
        <SearchFilter data={filter} onChange={onFilterChange} onSearch={onSearch}></SearchFilter>
      </section>
      <section className='table__container'>
        <TableBox data={list} header={header} rowClick={tableRowClick} callback={tableCallback}></TableBox>
      </section>
      <section className='paging__container'>
        <Paging page={page} totalPage={totalPage} onChange={onPageChange}></Paging>
      </section>
    </article>
  );
};
